import PropTypes from 'prop-types';
import React from 'react';
import {diffChars} from 'diff';
import {forEach} from 'lodash';
import Modal from 'shared/components/modal';
import RadioButton from 'src/components/radio-button';
import {getMedia} from 'shared/mq';
import {MODAL_IDENTIFIER} from 'shared/account-settings/address-verification';
import Address from './address';
import getTextDifferences from 'src/utils/getTextDifferences';

class SuggestedAddressModal extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    suggestedAddress: PropTypes.object.isRequired,
    submitForm: PropTypes.func.isRequired,
    originalAddress: PropTypes.object.isRequired,
    onVerifyAddress: PropTypes.func,
  };

  state = {
    originalAddress: false,
    suggestedAddress: true,
  };

  closeModal = () => {
    this.props.closeModal(MODAL_IDENTIFIER);
  };

  onSubmit = () => {
    const {closeModal, submitForm, onVerifyAddress, originalAddress, suggestedAddress} = this.props;

    if (this.state.suggestedAddress) {
      submitForm(
        {
          ...suggestedAddress,
          addressVerified: true,
          confirmedUnverifiedAddress: false,
        },
        getMedia().MS_AND_DOWN
      );
    } else {
      submitForm(
        {
          ...originalAddress,
          addressVerified: false,
          confirmedUnverifiedAddress: true,
        },
        getMedia().MS_AND_DOWN
      );
    }
    if (onVerifyAddress) {
      onVerifyAddress();
    }
    closeModal();
  };

  render() {
    const {closeModal, show, suggestedAddress, originalAddress} = this.props;

    const suggestedAddressWithDifferences = {...suggestedAddress};

    forEach(['addressLine1', 'addressLine2', 'city', 'subdivision', 'postalCode'], (property) => {
      const results = diffChars(originalAddress[property] || '', suggestedAddress[property] || '');
      suggestedAddressWithDifferences[property] = getTextDifferences(results);
    });

    return (
      <div>
        <Modal show={show} onClose={closeModal} className="address-verification-modal">
          <Modal.TextHeader onClose={closeModal}>
            Please pick a valid matching address
          </Modal.TextHeader>
          <Modal.Body>
            <p className="address-verification-modal-text">
              There&apos;s a problem with the address provided - we&apos;ve marked our suggestions
              in green below.
            </p>
            <fieldset role="radiogroup" aria-label="Please select an address">
              <RadioButton
                label={[
                  <Address type="Original" key="original-address" address={originalAddress} />,
                ]}
                name="address"
                onChange={() => {
                  this.setState({
                    suggestedAddress: false,
                    originalAddress: true,
                  });
                }}
                checked={this.state.originalAddress}
              />
              <hr aria-hidden="true" />
              <RadioButton
                label={[
                  <Address
                    type="Suggested"
                    key="suggested-address"
                    address={suggestedAddressWithDifferences}
                  />,
                ]}
                name="address"
                onChange={() => {
                  this.setState({
                    suggestedAddress: true,
                    originalAddress: false,
                  });
                }}
                checked={this.state.suggestedAddress}
              />
            </fieldset>

            <hr aria-hidden="true" />
          </Modal.Body>
          <Modal.Footer
            primaryButton={{
              text: 'Use Selected Address',
              onClick: this.onSubmit,
            }}
          />
        </Modal>
      </div>
    );
  }
}

export default SuggestedAddressModal;
